// Language/domain configuration.
// Production hosts stay in place. Dev hosts are the current llw.cz sites.
const SITES = {
  'cs-CZ': {
    name: 'Čeština',
    flag: 'cz',
    production: 'ridley-bikes.cz',
    dev: 'ridley-cz.llw.cz'
  },
  'sk-SK': {
    name: 'Slovenčina',
    flag: 'sk',
    production: 'ridley-bikes.sk',
    dev: 'ridley-sk.llw.cz'
  },
  'pl-PL': {
    name: 'Polski',
    flag: 'pl',
    production: 'ridley-bike.pl',
    dev: 'ridley-pl.llw.cz'
  },
  'hu-HU': {
    name: 'Magyar',
    flag: 'hu',
    production: 'ridley-bikes.hu',
    dev: 'ridley-hu.llw.cz'
  }
};

const HOST_TO_LOCALE = {
  localhost: 'cs-CZ',
  '127.0.0.1': 'cs-CZ'
};

for (const [locale, site] of Object.entries(SITES)) {
  HOST_TO_LOCALE[site.production] = locale;
  HOST_TO_LOCALE[`www.${site.production}`] = locale;
  HOST_TO_LOCALE[site.dev] = locale;
}

export const LANGUAGE_CONFIG = Object.fromEntries(
  Object.entries(SITES).map(([locale, site]) => [
    locale,
    {
      name: site.name,
      flag: site.flag,
      domain: site.production,
      devDomain: site.dev
    }
  ])
);

function currentHostname() {
  return window.location.hostname;
}

function isLocalHost(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

function isDevHost(hostname) {
  return hostname === 'llw.cz' || hostname.endsWith('.llw.cz');
}

export const getCurrentLanguage = () => {
  try {
    return HOST_TO_LOCALE[currentHostname()] || 'cs-CZ';
  } catch {
    return 'cs-CZ';
  }
};

export const switchLanguage = (targetLocale) => {
  const site = SITES[targetLocale];
  if (!site) {
    return;
  }

  const hostname = currentHostname();
  if (isLocalHost(hostname)) {
    return;
  }

  const targetHost = isDevHost(hostname) ? site.dev : site.production;
  if (targetHost === hostname) {
    return;
  }

  const currentPath = window.location.pathname + window.location.search + window.location.hash;
  window.location.href = `${window.location.protocol}//${targetHost}${currentPath}`;
};
